module.exports = __webpack_public_path__ + "static/fonts/righteous-regular.e2a427b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/righteous-regular.eot
// module id = LPpJ
// module chunks = 1